import {gql} from '@apollo/client';

export default gql`
  query getBrandOrganizationImpressionsCountryLocationQuery(
    $id: ID!
    $after: Date
    $before: Date
    $publisherIds: [ID]
    $campaignIds: [ID]
    $country: String
  ) {
    me {
      id
      organization(id: $id) {
        id
        overview {
          impressions(
            after: $after
            before: $before
            publisherIds: $publisherIds
            campaignIds: $campaignIds
          ) {
            locations(country: $country) {
              count
              regions {
                country
                region
                total
              }
              nodes {
                country
                region
                city
                latitude
                longitude
                count: total
              }
            }
          }
        }
      }
    }
  }
`;
